WiseMetering.Collection.ActuatorKinds = WiseMetering.Collection.extend({
    model: WiseMetering.Model.ActuatorKind
});
